import { createRouter, createWebHistory } from 'vue-router'
import type { Router } from 'vue-router'
import type { App } from 'vue'
import Layout from '@/layout/index.vue'
import { useUserStore } from '@/stores/user'
import Api from '@/api'
import { myFetchWithAuthRetry } from '@/api/request'
import { trackMetaPageView } from '@/utils/metaPixel'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: Layout,
      children: [{
        name: 'home',
        path: '',
        component: () => import('@/pages/home/index.vue'),
      }, {
        name: 'collection',
        path: '/collection',
        component: () => import('@/pages/collection/index.vue'),
      }]
    }, {
      path: '/search',
      component: () => import('@/pages/search/index.vue')
    }, {
      path: '/video/:id',
      component: () => import('@/pages/play/index.vue')
    }, {
      path: '/login',
      component: () => import('@/pages/login/index.vue')
    }, {
      path: '/profile',
      component: () => import('@/pages/profile.vue')
    }
  ],
})

function setupBefore(router: Router) {
  router.beforeEach(async (to, from, next) => {
    const useStore = useUserStore()
    if (to.path === '/login') {
      next()
      return
    }
    // 已经初始化过，直接放行
    if (useStore.isLogin) {
      next()
      return
    }
    try {
      const res = await myFetchWithAuthRetry(Api.userInfo)
      console.log('用户信息返回：', res)
      const resData = res?.data
      if (resData) {
        useStore.setUserInfo({
          id: resData.id || '',
          nickname: resData.nickname || '',
          coin: Number(resData.coin || 0),
          islogin: Number(resData.islogin || 0),
          isvip: Number(resData.isvip || 0),
          vipleftbtntxt: resData.vipleftbtntxt || '',
        })
      }
      useStore.setLoginStatus(true)
    } catch (err) {
      console.error('初始化用户信息失败：', err)
      /**
       * 注意：
       * 初始化失败也要放行，不然 502 时页面会卡死。
       */
      useStore.clearAuth()
      useStore.setLoginStatus(true)
    }
    next()
  })
}


router.afterEach((to, from) => {
  trackMetaPageView({
    route_path: to.fullPath,
    route_name: typeof to.name === 'string' ? to.name : '',
    page_name: typeof to.name === 'string' ? to.name : '',
    source_page: from.fullPath || '',
  })
})

export default router

export function initRouter(app: App<Element>) {
  setupBefore(router) // 路由前置守卫
  app.use(router)
}
